// Registro central de partners co-branded de MiMaquinaSegura.cl.
//
// Cada partner soporta:
//   - code:        identificador corto en MAYÚSCULAS (BD/CRM).
//   - name:        nombre visible.
//   - path:        segmento de URL / subdominio. Ej: "rutapesada" => /RutaPesada
//   - logos:       array de logos para el header (uno o más) — sobre fondo claro.
//                  Cada entry: { src, alt, className? } (className opcional para ajustar tamaño)
//   - logo:        (legacy) logo único; ignorado si `logos` está presente.
//   - logoWhite:   logo para banner oscuro. Si vacío o `bannerHideLogos: true`, el
//                  banner del Hero muestra sólo texto.
//   - bannerText:  texto del banner del Hero.
//   - bannerHideLogos: si true, el banner del Hero muestra sólo texto (no logos).
//   - whatsappMessage: (opcional) mensaje precargado en el botón flotante de WhatsApp.
//                      Si no se define, se usa el mensaje global de constants/site.js.
export const PARTNERS = [
  {
    code: "RUTAPESADA",
    name: "Ruta Pesada + Doris Quiroz",
    path: "rutapesada",
    logos: [
      { src: "/brand/partners/dorisquiroz.png", alt: "DorisQuiroz.cl", className: "h-10 sm:h-12 md:h-14" },
      { src: "/brand/partners/rutapesada.png", alt: "RutaPesada.cl", className: "h-10 sm:h-12 md:h-14" },
    ],
    bannerText:
      "Beneficio exclusivo para clientes y partners de DorisQuiroz.cl y RutaPesada.cl",
    bannerHideLogos: true,
    whatsappMessage:
      "Hola! Vengo de la alianza RutaPesada + DorisQuiroz. Me gustaría cotizar un seguro para maquinaria.",
  },
];

export const getPartnerByPath = (segment) =>
  PARTNERS.find((p) => p.path.toLowerCase() === (segment || "").toLowerCase()) || null;

export const getPartnerByCode = (code) =>
  PARTNERS.find((p) => p.code.toLowerCase() === (code || "").toLowerCase()) || null;
